import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import logo from "../assets/images/logo1.png";
import { logoutHandler } from "../utils/Helper";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const params = useParams();
  const url = window.location.pathname;

  const { user_info } = useSelector((state) => state.userInfo);

  useEffect(() => {}, [user_info]);

  return (
    <aside
      className="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered"
      style={{ backgroundColor: "#25282a" }}
    >
      <div className="navbar-vertical-container">
        <div className="navbar-vertical-footer-offset">
          {/* Logo */}
          <Link
            className="d-flex justify-content-center pt-2"
            to="/"
            aria-label="Front"
          >
            <img
              className="mx-auto"
              src={logo}
              alt="Logo"
              style={{ width: "90px" }}
            />
          </Link>
          {/* End Logo */}

          {/* Navbar Vertical Toggle */}
          <button
            type="button"
            className="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler"
          >
            <i
              className="bi-arrow-bar-left navbar-toggler-short-align"
              data-bs-template='<div className="tooltip d-none d-md-block" role="tooltip"><div className="arrow"></div><div className="tooltip-inner"></div></div>'
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Collapse"
            ></i>
            <i
              className="bi-arrow-bar-right navbar-toggler-full-align"
              data-bs-template='<div className="tooltip d-none d-md-block" role="tooltip"><div className="arrow"></div><div className="tooltip-inner"></div></div>'
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Expand"
            ></i>
          </button>
          {/* End Navbar Vertical Toggle */}
          <div className="navbar-vertical-content">
            <div
              id="navbarVerticalMenu"
              className="nav nav-pills nav-vertical card-navbar-nav"
            >
              <div className="nav-item">
                <Link
                  className={`nav-link ${
                    (url === "/users" || url === "/") && "active"
                  }`}
                  to="/users"
                >
                  <i className="bi-people nav-icon"></i>
                  <span className="nav-link-title">Users</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${url === "/bet-lists" && "active"}`}
                  to="/bet-lists"
                >
                  <i className="bi bi-list-task nav-icon"></i>
                  <span className="nav-link-title">Bet Lists</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${url === "/winners" && "active"}`}
                  to="/winners"
                >
                  <i className="bi bi-trophy nav-icon"></i>
                  <span className="nav-link-title">Winners</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${url === "/results" && "active"}`}
                  to="/results"
                >
                  <i className="bi-arrow-repeat nav-icon"></i>
                  <span className="nav-link-title">Results</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${
                    url === "/transaction-history" && "active"
                  }`}
                  to="/transaction-history"
                >
                  <i className="bi-clock-history nav-icon"></i>
                  <span className="nav-link-title">Transactions History</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${url === "/deposits" && "active"}`}
                  to="/deposits"
                >
                  <i className="bi bi-bank nav-icon"></i>
                  <span className="nav-link-title">Depostis</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${url === "/withdraws" && "active"}`}
                  to="/withdraws"
                >
                  <i className="bi bi-bank nav-icon"></i>
                  <span className="nav-link-title">Withdraws</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${
                    url === "/payment-providers" && "active"
                  }`}
                  to="/payment-providers"
                >
                  <i className="bi bi-credit-card-2-front nav-icon"></i>
                  <span className="nav-link-title">Payment Providers</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${url === "/settings" && "active"}`}
                  to="/settings"
                >
                  <i className="bi bi-sliders nav-icon"></i>
                  <span className="nav-link-title">Settings</span>
                </Link>
              </div>

              <div className="nav-item">
                <Link
                  className="nav-link dropdown-toggle collapsed"
                  to="#nav_vertical_reports"
                  role="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nav_vertical_reports"
                  aria-expanded="false"
                  aria-controls="nav_vertical_reports"
                >
                  <i className="bi bi-folder nav-icon"></i>
                  <span className="nav-link-title">Reports</span>
                </Link>
                <div
                  id="nav_vertical_reports"
                  className={`nav-collapse collapse ${
                    (url === "/user-reports" ||
                      url === "/payment-reports" ||
                      url === "/deposit-withdraw-reports" ||
                      url === "/session-reports" ||
                      url === "/session-reports/" + params.result_id) &&
                    "show"
                  }`}
                  data-bs-parent="#navbarVerticalMenuAccount"
                >
                  <Link
                    className={`nav-link ${
                      url === "/user-reports" && "active"
                    }`}
                    to="/user-reports"
                  >
                    User Reports
                  </Link>{" "}
                  <Link
                    className={`nav-link ${
                      url === "/payment-reports" && "active"
                    }`}
                    to="/payment-reports"
                  >
                    Payment Reports
                  </Link>
                  <Link
                    className={`nav-link ${
                      url === "/deposit-withdraw-reports" && "active"
                    }`}
                    to="/deposit-withdraw-reports"
                  >
                    Deposit & Withdraw Reports
                  </Link>
                  <Link
                    className={`nav-link ${
                      url === "/session-reports" && "active"
                    }`}
                    to="/session-reports"
                  >
                    Session Reports
                  </Link>
                </div>
              </div>

              <div className="nav-item">
                <Link
                  className={`nav-link ${
                    url === "/change-password" && "active"
                  }`}
                  to="/change-password"
                >
                  <i className="bi-key-fill nav-icon"></i>
                  <span className="nav-link-title">Change Password</span>
                </Link>
              </div>

              {user_info?.user_role === "admin" && (
                <div className="nav-item">
                  <Link
                    className={`nav-link ${url === "/banner" && "active"}`}
                    to="/banner"
                  >
                    <i className="bi-image nav-icon"></i>
                    <span className="nav-link-title">Banner</span>
                  </Link>
                </div>
              )}
              <span className="mt-4 dropdown-header">Logout</span>
              <small className="bi-three-dots nav-subtitle-replacer"></small>
              <div className="nav-item">
                <Link
                  className="nav-link"
                  style={{ cursor: "pointer" }}
                  onClick={logoutHandler}
                >
                  <i className="bi bi-box-arrow-right nav-icon"></i>
                  <span className="nav-link-title">Logout</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
